module.exports = __webpack_public_path__ + "static/media/Water noAward.13c2f620.svg";